import React, { useCallback, useEffect, useRef } from 'react';

import { FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import getValidationErrors from '../../utils/getValidationErrors';

// import logoImg from '../../assets/logo.svg';
import {config} from '../../config';

import { signInRequest } from '../../store/modules/auth/actions';

import Input from '../../components/Input';
import Button from '../../components/Button';

import {
  Container,
  AnimationContainer,
  Title,
  ColInput,
  Register,
  Forget,
  ButtonGoogle
} from './styles';

import { StoreState } from '../../store/createStore';
import {
  setIsCategory,
  viewModal,
} from '../../store/modules/parameter/actions';
import SignUp from '../SignUp';
import ForgetPassword from '../ForgotPassword';
import ButtonSocial from '../../components/ButtonSocial';

interface SingUpFormData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const { onTranslation: t } = useTranslation();
  const formRef = useRef<FormHandles>(null);
  const { loadingSignInRequest, error, message } = useSelector(
    (state: StoreState) => state.auth,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const handleSubmit = useCallback(
    async (data: SingUpFormData) => {
      try {
        formRef.current?.setErrors({});
        if (process.env.REACT_APP_SELLER_MODE === '0') {
          const schema = Yup.object().shape({
            email: Yup.string()
              .required(t('main.messages_yup.email_required'))
              .email(t('main.messages_yup.email_invalid')),
            password: Yup.string()
              // .required('Senha obrigatória')
              .min(6, `${t('main.messages_yup.min')} 6 ${t('main.messages_yup.digits')}`),
          });

          await schema.validate(data, {
            abortEarly: false,
          });
        }

        dispatch(
          signInRequest({
            email: data.email,
            password: data.password,
          }),
        );
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [dispatch, t],
  );

  const handledRegister = useCallback(() => {
    dispatch(viewModal(SignUp, { width: '50%', height: '100%' }));
  }, [dispatch]);

  const handleForgetPass = useCallback(() => {
    dispatch(viewModal(ForgetPassword, { width: '50%', height: '100%' }));
  }, [dispatch]);

  return (
    <Container>
      <AnimationContainer>
        <img src={config.logo} alt="ConectoVarejo" />

        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {/* Campos falsos para enganar o autocomplete do navegador */}
          <input type="text" name="fakeusernameremembered" style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }} />
          <input type="password" name="fakepasswordremembered" style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }} />
          
          <Title>
            <span>{t('main.modal_login.welcome_message_1')}</span>
            <p>{t('main.modal_login.welcome_message_2')}</p>
          </Title>
          {error && (
            <Title style={{ backgroundColor: '#f1efef', padding: 8, borderRadius: 8 }}>
              <p style={{ color: 'red' }}>{message}</p>
            </Title>
          )}

          <ColInput>
            <div style={{ marginBottom: '20px' }} />
          </ColInput>
          {
            process.env.REACT_APP_SELLER_MODE === '1' ? (
              <ColInput>
                <Input icon={FiUser} name="email" textLabel="Id vendedor" type="number" formRef={formRef} autoComplete="off" />
              </ColInput>
            ) : (
              <ColInput>
                <Input icon={FiMail} name="email" textLabel={t('main.modal_login.input_email')} formRef={formRef} autoComplete="off" />
              </ColInput>
            )
          }


          <ColInput>
            <Input
              icon={FiLock}
              type="password"
              name="password"
              textLabel={t('main.modal_login.input_password')}
              formRef={formRef}
              autoComplete="new-password"
            />
          </ColInput>

          <ColInput>
            <Button
              button={{ type: loadingSignInRequest ? 'button' : 'submit' }}
              atributes={{
                buttonType: 'primary',
                textColor: '#fff',
                textSize: '30px',
                borderColor: '#dddddd',
              }}
            >
              {loadingSignInRequest ?  t('main.modal_login.button_wait') : t('main.modal_login.button_login')}
            </Button>
          </ColInput>
        </Form>
        { process.env.REACT_APP_ALLOWED_LOGIN_SOCIAL === '1' &&
          <ButtonGoogle>
            <ButtonSocial type='google' title={ t('main.modal_login.button_login_google')} icone={{ icon: FcGoogle, direction: 'right', size: 20, color: '' }} />
          </ButtonGoogle>
        }
        {
          process.env.REACT_APP_SELLER_MODE === '0' && (
            <Register>
              <span>
              { t('main.modal_login.dont_have_an_account')}  <button onClick={handledRegister}>{t('main.modal_login.register')}</button>
              </span>
            </Register>
          )
        }
        <Forget onClick={handleForgetPass}>
          <span>
            <b>{ t('main.modal_login.forgot_password')}</b>
          </span>
        </Forget>
      </AnimationContainer>
    </Container>
  );
};

export default SignIn;
